/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S12_Support_LabelInputs */

const tr_mesafeli_s12_support_label = /** @type {(inputs: Mesafeli_S12_Support_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destek yanıt süresi:`)
};

const en_mesafeli_s12_support_label = /** @type {(inputs: Mesafeli_S12_Support_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support response time:`)
};

const de_mesafeli_s12_support_label = /** @type {(inputs: Mesafeli_S12_Support_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reaktionszeit des Supports:`)
};

const ru_mesafeli_s12_support_label = /** @type {(inputs: Mesafeli_S12_Support_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время ответа поддержки:`)
};

/**
* | output |
* | --- |
* | "Support response time:" |
*
* @param {Mesafeli_S12_Support_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s12_support_label = /** @type {((inputs?: Mesafeli_S12_Support_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S12_Support_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s12_support_label(inputs)
	if (locale === "de") return de_mesafeli_s12_support_label(inputs)
	if (locale === "ru") return ru_mesafeli_s12_support_label(inputs)
	return tr_mesafeli_s12_support_label(inputs)
});